import { http, HttpResponse } from 'msw';

import { step } from './fixture/requirement';
import { token } from './fixture/token';

export const tokenHandlers = [
  http.get('**/:signatureRequestKey/steps/email', () => HttpResponse.json(step('email'))),
  http.get('**/:signatureRequestKey/token', () => HttpResponse.json(token)),
];
